import React, { Component } from "react";
import { toast } from "react-toastify";
import userService from "../../Services/userService";
import AddClientFillsToDeal from "../widgets/addClientFillsToDeal";
import { clientEditsRejected } from "../../global/popupMessages";
import AssessmentIcon from "@material-ui/icons/Assessment";
// import AssessmentIcon from "@material-ui/icons/Assessment";

import { connect } from "react-redux";
import Swal from "sweetalert2";

class NotificationsCenter extends Component {
  state = {
    isPopupOpen: false,
    currentDeal: null,
    firstTimeAfterRefresh: true
  };

  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.isLoggedIn && this.state.firstTimeAfterRefresh) {
  //     this.setState({ firstTimeAfterRefresh: false }, () => {
  //       this.initNotifications();
  //     });
  //   }
  // }

  // componentDidMount() {
  //   if (this.props.isLoggedIn) {
  //     this.initNotifications();
  //     this.setState({ firstTimeAfterRefresh: false });
  //   }
  // }

  render() {
    var role = localStorage.getItem("role");

    return (
      <div>
        {(this.props.isLoggedIn && role === "admin") || role === "salesManager" ? (
          <div id="trigger-notifications" onClick={() => window.location.assign("/admin/track-employees")}>
            <div className="fill-notification-space">
              <div className="trigger-noti-txt">מעקב עובדים</div>
              <div className="notification-icon adjust-icon-position">
                <AssessmentIcon />
              </div>
            </div>
          </div>
        ) : null}

        <AddClientFillsToDeal
          isOpen={this.state.isPopupOpen}
          currentDeal={this.state.currentDeal}
          closePopup={this.closePopup}
          approveSelectedEdits={this.approveSelectedEdits}
          rejectClientEdits={this.rejectClientEdits}
        />
      </div>
    );
  }

  // reinitNotifications = () => {
  //   toast.dismiss();
  //   this.initNotifications(true);
  // };

  // initNotifications = (isUserClicked) => {
  //   userService.getNotifications().then((res) => {
  //     if (res["success"]) {
  //       var notifications = res["notifications"];
  //       if (isUserClicked && (!notifications || !notifications[0])) {
  //         Swal.fire("אין התראות חדשות", "", "success");
  //         return;
  //       }
  //       for (const notification of notifications) {
  //         var buildTitleMsg = "";
  //         var buildBodyMsg = "";
  //         if (notification.fields && notification.fields.firstName && notification.fields.lastName) {
  //           buildTitleMsg = "נתונים לעסקה נקלטו עבור לקוח בשם: ";
  //           buildBodyMsg = `${notification.fields.firstName} ${notification.fields.lastName}`;
  //         } else if (notification.dealName) {
  //           buildTitleMsg = "נתונים נקלטו לעסקה בשם: ";
  //           buildBodyMsg = notification.dealName;
  //         } else if (notification.clientFillsJob && notification.clientFillsJob.clientEmail) {
  //           buildTitleMsg = "נתונים לעסקה נקלטו ללקוח עם אימייל: ";
  //           buildBodyMsg = notification.clientFillsJob.clientEmail;
  //         }
  //         toast(
  //           <MsgContent
  //             buildTitleMsg={buildTitleMsg}
  //             buildBodyMsg={buildBodyMsg}
  //             currentDeal={notification}
  //             displayFieldsFromClient={this.displayFieldsFromClient}
  //           />,
  //           {
  //             position: toast.POSITION.TOP_LEFT,
  //             autoClose: 200000,
  //             type: "warning"
  //           }
  //         );
  //       }
  //     }
  //   });
  // };

  approveSelectedEdits = (dealToApproveEdits) => {
    Swal.fire({
      title: "להוסיף נתונים שאושרו על ידך לעסקה?",
      text: "",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        var updates = dealToApproveEdits.createClientUI.filter((item) => !item.isDeleted);
        userService.approveNotificationEdits(dealToApproveEdits._id, updates).then((res) => {
          if (res["success"]) {
            this.closePopup();
            Swal.fire("בוצע", clientEditsRejected);
          }
        });
      }
    });
  };

  rejectClientEdits = () => {
    Swal.fire({
      title: "למחוק את הנתונים שהלקוח הזין?",
      text: "האם אתה בטוח?",
      icon: "warning",
      showCancelButton: true
    }).then((result) => {
      if (result.value) {
        userService.rejectNotification(this.state.currentDeal._id).then((res) => {
          if (res["success"]) {
            this.closePopup();
            Swal.fire("בוצע", clientEditsRejected);
          }
        });
      }
    });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false });
  };

  displayFieldsFromClient = (currentDeal) => {
    this.setState({ isPopupOpen: true, currentDeal });
  };
}

class MsgContent extends Component {
  render() {
    return (
      <div
        onClick={() => {
          this.props.displayFieldsFromClient(this.props.currentDeal);
        }}
        className="fill-notification-space"
      >
        <div className="notification-txt">
          {this.props.buildTitleMsg}
          <br />
          <b className="underline">{this.props.buildBodyMsg}</b>
        </div>
        <div className="notification-icon">
          <i className="material-icons">notifications_active</i>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.authReducer.isLoggedIn
  };
};

export default connect(mapStateToProps)(NotificationsCenter);
